export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const { jwtCookie, logout } = useAuth()
  const { isWebview } = useWebviewBridge()

  const api = $fetch.create({
    baseURL: runtimeConfig.public.napiDomain,

    onRequest({ options }) {
      options.headers = new Headers(options.headers)
      options.headers.set('Authorization', `Bearer ${jwtCookie.value ?? ''}`)
      options.headers.set('x-from-app', isWebview.value ? 'true' : 'false')
    },

    onResponse({ response }) {
      const refreshedToken = response.headers.get('x-refresh-token')
      if (refreshedToken) {
        jwtCookie.value = refreshedToken
      }
    },

    onResponseError({ response }) {
      if (response.status === 401) {
        logout()
      }
    },
  })

  return { provide: { api } }
})
